import React, { useMemo } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { faIcons } from "../fa.icons";

/**
 * Searchable FontAwesome icon picker. Renders the actual glyph next to its
 * name so users can recognise icons visually instead of guessing class names.
 */
export default function IconPicker({ value, onChange, label = "Icon", size = "small" }) {
  const options = useMemo(() => faIcons, []);

  return (
    <Autocomplete
      size={size}
      options={options}
      value={value || null}
      onChange={(_e, next) => onChange(next || "")}
      isOptionEqualToValue={(opt, val) => opt === val}
      getOptionLabel={(opt) => (opt ? opt.replace(/^fa-/, "").replace(/-/g, " ") : "")}
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ display: "flex", gap: 1.5 }}>
          <i className={option} style={{ width: 18, textAlign: "center" }} />
          <span>{option.replace(/^fa-/, "").replace(/-/g, " ")}</span>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Search icons"
          InputProps={{
            ...params.InputProps,
            startAdornment: value ? (
              <i className={value} style={{ marginLeft: 8, marginRight: 2 }} />
            ) : null,
          }}
        />
      )}
    />
  );
}
